import { colors } from 'fitify-ui'
import { typographyStyles } from 'fitify-ui/src/typography/generated/Typography'
import { phone } from 'fitify-ui-landing/src/theme/breakpoints'
import Link from 'next/link'
import styled, { css } from 'styled-components'

export const StyledBreadcrumbs = styled.nav`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  color: ${colors.Gray600};
  gap: 8px;
  ${typographyStyles('Text/Body 14')}

  ${phone(css`
    gap: 6px;
    ${typographyStyles('Text/Body 12')}
  `)};
`

export const StyledLink = styled(Link)`
  color: ${colors.Blue400};
  text-decoration: none;
  transition: color 100ms ease-in-out;

  &:hover {
    color: ${colors.Blue600};
    text-decoration: underline;
  }
`

export const StyledSeparator = styled.span`
  color: ${colors.Gray400};
`

export const StyledCurrent = styled.span`
  color: ${colors.Gray700};
`

export const StyledBreadcrumbItem = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;

  ${phone(css`
    gap: 6px;
  `)};
`
